import React, { Component } from "react";
import { withOktaAuth } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";

class OktaSignInWidget extends Component {
  constructor(props) {
    super(props);

    this.oktaAuth = new OktaAuth({
      issuer: props.baseUrl,
      clientId: props.clientId,
      pkce: true
    });
  }
  async componentDidMount() {
    console.log("signin widget component is rendered ")
    this.login();
  }
  async login() {
    await this.props.oktaAuth.signInWithRedirect({
      scopes: ['openid', 'profile', 'email', 'offline_access']
    });
  }

  render() {
    return (
      <div>
        <p>Redirecting to Okta...</p>
      </div>
    );
  }
}

export default withOktaAuth(OktaSignInWidget);